<div
  [class]="
    'flex flex-col rounded-(--detailcard-border-radius) gap-(--detailcard-gap) px-(--detailcard-padding-x) py-(--detailcard-padding-y) w-full ' +
    (config().border
      ? 'border-(length:--detailcard-border-width,var(--border-width-xs)) border-solid border-(--detailcard-border-color)'
      : '')
  "
  [style.background]="containerBackground()"
>
  @if (chipProps(); as props) {
    <div class="self-start">
      <app-dynamic
        componentName="Chip"
        [props]="props"
      />
    </div>
  }
  @if (titleProps(); as propsArray) {
    @if (propsArray.length > 0) {
      <div class="flex flex-col gap-1">
        @for (props of propsArray; track $index) {
          <app-dynamic
            componentName="DynamicText"
            [props]="props"
          />
        }
      </div>
    }
  }
  @if (subtextProps(); as propsArray) {
    @if (propsArray.length > 0) {
      <div [class]="'flex flex-col' + (hasListLayout() ? '' : ' gap-4')">
        @for (props of propsArray; track $index) {
          @if (hasListLayout()) {
            <div class="flex gap-2">
              <!-- h-[1.1lh] aligns the bullet vertically with the first line of text -->
              <div class="flex items-center h-[1.1lh]">
                <div
                  class="size-1 shrink-0 rounded-full"
                  [style.background-color]="props.config.color"
                ></div>
              </div>
              <app-dynamic
                componentName="DynamicText"
                [props]="props"
              />
            </div>
          } @else {
            <app-dynamic
              componentName="DynamicText"
              [props]="props"
            />
          }
        }
      </div>
    }
  }
  @if (descriptionProps(); as props) {
    <app-dynamic
      componentName="DynamicText"
      [props]="props"
    />
  }
  @if (fieldProps(); as propsArray) {
    @if (propsArray.length > 0) {
      <div class="flex flex-col gap-4">
        @for (field of propsArray; track $index) {
          <div class="flex flex-col gap-1">
            <app-dynamic
              componentName="DynamicText"
              [props]="field.titleProps"
            />
            <app-dynamic
              componentName="DynamicText"
              [props]="field.contentProps"
            />
          </div>
        }
      </div>
    }
  }
</div>
